import React, { useEffect, useState } from 'react';
import {
  formatDate,
  formatDateMethod,
  monthBtnStyle,
  monthBtnSelectedStyle,
  monthBtnSelectedRangeStyle,
  monthButtonDisabledStyle
} from '../helper';
import { DateRange } from '../../../types';
import moment from 'moment';

interface MonthProps {
  month: string;
  variant: string;
  startDate: string;
  endDate: string;
  startYear: number;
  endYear: number;
  monthClicked: any;
  rangeLimit: Array<DateRange>;
}

const Month = ({ month, variant, startDate, endDate, startYear, endYear, monthClicked, rangeLimit }: MonthProps) => {
  const [selected, setSelected] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [styleSelected, setSelectedStyle] = useState(monthBtnSelectedRangeStyle);

  // check if month is within range of start and end date
  const isInRange = (month: string, year: number): boolean => {
    const startD = formatDate(startDate);
    const endD = formatDate(endDate);
    const current = formatDateMethod(month, year);
    const inRange = endD > current && current > startD;
    return inRange;
  };

  //checking if month is less than current month
  const validateMonth = () => {
    setDisabled(
      !(
        formatDateMethod(month, endYear) <=
        formatDateMethod(moment(rangeLimit[0].startDate).format('MMM'), new Date().getFullYear())
      )
    );
  };

  //only validating right calendar for valid month
  useEffect(() => {
    if (variant === 'right') {
      validateMonth();
    }
    //eslint-disable-next-line
  }, [endYear]);

  //changing style classes based on month selection
  useEffect(() => {
    switch (variant) {
      case 'left': {
        if (`${month} ${startYear}` === startDate || `${month} ${startYear}` === endDate) {
          setSelectedStyle(monthBtnSelectedStyle);
          setSelected(true);
        } else if (isInRange(month, startYear)) {
          setSelectedStyle(monthBtnSelectedRangeStyle);
          setSelected(true);
        } else setSelected(false);
        break;
      }
      case 'right': {
        if (`${month} ${endYear}` === startDate || `${month} ${endYear}` === endDate) {
          setSelectedStyle(monthBtnSelectedStyle);
          setSelected(true);
        } else if (isInRange(month, endYear)) {
          setSelectedStyle(monthBtnSelectedRangeStyle);
          setSelected(true);
        } else setSelected(false);
        break;
      }
    }
    //eslint-disable-next-line
  }, [startDate, endDate, startYear, endYear, month, variant]);

  return (
    <button
      className={disabled ? monthButtonDisabledStyle : selected ? styleSelected : monthBtnStyle}
      onClick={(e) => monthClicked(e)}
      disabled={disabled}
    >
      {month}
    </button>
  );
};

export default Month;
